import FlexColumn from "../../../common/components/layout/Flexbox/FlexColumn";
import FlexRow from "../../../common/components/layout/Flexbox/FlexRow";
import TextField from "../../../common/components/display/TextField/TextField";
import BorderedPanel from "../../../common/components/display/BorderedPanel/BorderedPanel";

import "./CharacterProfileProficiencies_style.css";

type Props = {
    proficiencies: {
        strength: number;
        agility: number;
        intelligence: number;
        fortitude: number;
        charisma: number;
    };
};

export default function CharacterProfileProficiencies({
    proficiencies,
}: Props): JSX.Element {
    const highest = Math.max(
        proficiencies.strength,
        proficiencies.agility,
        proficiencies.intelligence,
        proficiencies.fortitude,
        proficiencies.charisma
    );

    const createProfPanel = (prof: { label: string; score: number }) => {
        return (
            <FlexColumn
                key={prof.label}
                className={`profile-proficiency-container${
                    prof.score === highest ? ` highest` : ``
                }`}
                style={{ justifyItems: "center" }}
            >
                <FlexRow alignment="center">
                    <TextField type="bold">{prof.label}</TextField>
                </FlexRow>
                <FlexRow alignment="center">
                    <TextField>{prof.score.toString()}</TextField>
                </FlexRow>
            </FlexColumn>
        );
    };

    return (
        <FlexRow wrap={true}>
            {[
                { label: "STR", score: proficiencies.strength },
                { label: "AGI", score: proficiencies.agility },
                { label: "INT", score: proficiencies.intelligence },
                { label: "FOR", score: proficiencies.fortitude },
                { label: "CHA", score: proficiencies.charisma },
            ].map((prof) => createProfPanel(prof))}
        </FlexRow>
    );
}
